var StreamVideoGroup = require("./video-group.js");

var wo_left = 0;
var wo_top = 0;

var STREAM_VG = null;

var window_status = null;
var window_share_screen = null;
var extra_windows = [];

/*
TODO: cambiar el origen del audio del manager
// Setting an audio source to a new MediaStreamTrack
const stream = await OT.getUserMedia({
  videoSource: null
});

const [audioSource] = stream.getAudioTracks();
publisher.setAudioSource(audioSource).then(() => console.log('Audio source updated'));

// Cycling through microphone inputs
let audioInputs;
let currentIndex = 0;
OT.getDevices((err, devices) => {
  audioInputs = devices.filter((device) => device.kind === 'audioInput');
  // Find the right starting index for cycleMicrophone
  audioInputs.forEach((device, idx) => {
    if (device.label === publisher.getAudioSource().label) {
      currentIndex = idx;
    }
  });
});

const cycleMicrophone = () => {
  currentIndex += 1;
  let deviceId = audioInputs[currentIndex % audioInputs.length].deviceId;
  publisher.setAudioSource(deviceId);
};
*/

init_manager();

window.onunload = function () {
    if (window_status) {
        window_status.close();
    }

    if (window_share_screen) {
        window_share_screen.close();
    }
    
    if (extra_windows && extra_windows.length) {
        for (var i = 0; i < extra_windows.length; i++) {
            extra_windows[i].close();
        }
    }
};

function init_manager() {
    $(".stream-video-group").each(function () {
        var $this = $(this);

        /*
            <div class="row">
                <div class="col-4 my-1 mx-1">
                    <button class="btn btn-primary btn-reload">Recargar</button>
                </div>
                <div class="col my-1">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input share-screen" id="share-screen">
                        <label class="custom-control-label" for="share-screen">{% trans 'Compartir pantalla' %}</label>
                    </div>
                </div>
            </div>

            $this.find(".btn-reload").off("click").on("click", function () {
                console.log("XXXXXXXXX");
                STREAM_VG.destroy();
                $this.find("video").remove();
                init_manager();
            });
        */

        window_status = window_open({
            url: $this.data("status-window-url"),
            name: "room-window-status",
            on_document_ready: function (new_window) {
                var $sw = new_window.$;

                $sw("#muteAllParticipants").on("change", function () {
                    var $mute_all = $(this);
                    if ($mute_all.prop('checked')) {
                        $sw(".mute-participant").prop('checked', true);
                        STREAM_VG.mute_all();
                    } else {
                        $sw(".mute-participant").prop('checked', false);
                        STREAM_VG.unmute_all();
                    }
                });

                $sw(".participant").each(function () {
                    var $participant = $(this);
                    var participant_id = $participant.data("id");

                    $participant.find(".mute-participant").on("change", function () {
                        var $mute_check = $(this);
                        if ($mute_check.prop('checked')) {
                            STREAM_VG.mute(participant_id);
                        } else {
                            STREAM_VG.unmute(participant_id);
                        }
                    });

                    $participant.find(".share-screen").on("change", function () {
                        var $share_screen = $(this);
                        if ($share_screen.prop('checked')) {
                            STREAM_VG.share_screen(participant_id);
                        } else {
                            STREAM_VG.unshare_screen(participant_id);
                        }
                    });

                    $participant.find(".reload").on("click", function () {
                        STREAM_VG.reload(participant_id);
                    });

                });
            }
        });

        window_share_screen = window_open({
            url: $this.data("screen-share-window-url"),
            name: "room-window-screen-share"
        });

        var eeww_total = parseInt($this.data("extra-windows"), 10);

        if (eeww_total) {
            for (var i = 0; i < eeww_total; i++) {
                var window_index = i + 1;
                var url = $this.data("eww-url-" + window_index);

                extra_windows[i] = window_open({
                    url: url,
                    name: "room-window-" + window_index
                });

                /*
                extra_windows[i] = window.open(
                    url,
                    "room-window-" + window_index,
                    "resizable,scrollbars,status"
                );
                */
            }
        }

        init_after_windows_load();

        function init_after_windows_load() {
            var windows_load = true;
            
            if (window_status && window_status.window_is_loaded && 
                window_share_screen && window_share_screen.window_is_loaded) {

                if (extra_windows && extra_windows.length) {
                    for (var i = 0; i < extra_windows.length; i++) {
                        if (!extra_windows[i].window_is_loaded) {
                            windows_load = false;
                            break;
                        }
                    }
                }
            } else {
                windows_load = false;
            }

            if (windows_load) {
                init_stream_vg();
            } else {
                setTimeout(init_after_windows_load, 500);
            }
        }

        function init_stream_vg() {
            STREAM_VG = new StreamVideoGroup($this, {
                subscriber_on_videoElementCreated: function (participant_id, event, stream) {
                    if (stream.name == "screen-share") {
                        window_status.$("#participant-" + participant_id + " .share-screen").prop('checked', true);
    
                        if (window_share_screen.$("#share-screen-" + participant_id).length == 0) {
                            window_share_screen.$("#share-screen").append(
                                window_share_screen.$('<div class="screen-share"></div>').attr("id", "screen-share-" + participant_id).append(
                                    event.element
                                )
                            );
                        } else {
                            window_share_screen.$("#share-screen-" + participant_id).append(
                                event.element
                            );
                        }
                    } else {
                        if ($("#participant-" + participant_id).length > 0 && $("#participant-" + participant_id + " video").length == 0) {
                            set_participant_status_online(participant_id);
    
                            STREAM_VG.insert_participant_video(
                                document.getElementById("wrap-participant-" + participant_id), 
                                event.element
                            );
                        } else {
                            var found_participant = false;
                            var extra_error = "";
                            // Se trata de uno que puede estar en una ventana
                            for (var i = 0; i < extra_windows.length; i++) {
                                var window_index = i + 1;
                                if (match_participant_window(window_index, participant_id)) {
                                    var wwcc = extra_windows[i];
                                    if (wwcc.$("#participant-" + participant_id).length > 0) {
                                        found_participant = true;
                                        set_participant_status_online(participant_id);
    
                                        if (wwcc.$("#participant-" + participant_id + " video").length == 0) {
                                            STREAM_VG.insert_participant_video(
                                                wwcc.document.getElementById("wrap-participant-" + participant_id), 
                                                event.element
                                            );                                      
                                        }
                                    } else {
                                        // TODO: i18n
                                        extra_error += " en la ventana indice " + window_index + "\n";
                                    }
                                    break;
                                }
                            }
    
                            if (!found_participant) {
                                // TODO: i18n
                                insert_log_entry({
                                    message: "No encontramos al participante que se acaba de unir con id " + participant_id + extra_error
                                });
                            }
                        }
                    }
                }, subscriber_on_end_communication: function (participant_id, event) {
                    var $sw = window_status.$;
                    if (participant_id == null) {
                        $sw(".participant").each(function (e) {
                            var $participant = $sw(this);
                            if ($participant.data("status") == "online") {
                                var window_index = $participant.data("window-index");
                                var $window = window_index ? extra_windows[window_index - 1] : window;
                                // console.log($window.$("#participant-" + $participant.data("id")).html());
                                if ($window.$("#wrap-participant-" + $participant.data("id")).html() == "") {
                                    participant_id = $participant.data("id");
                                }
                            }
                        });
                    }

                    if (participant_id != null) {
                        set_participant_status_offline(participant_id);
                    }
                }, on_signal: function (event, o) {
                    if (o && o.action) {
                        if (o.action == "send-msg-manager") {
                            insert_log_entry(o);
                        } else if (o.action == "error-share-screen") {
                            window_status.$("#participant-" + o.participant_id + " .share-screen").prop('checked', false);
                        }
                    } else {
                        console.log("manager:on_signal");
                        console.log(event);
                        console.log(o);
                    }
                }
            });
        }

        function match_participant_window(window_index, participant_id) {
            var participants = $this.data("eww-participants-" + window_index).split(" ");

            for (var i = 0; i < participants.length; i++) {
                if (participants[i] == participant_id) {
                    return true;
                }
            }

            return false;
        }
    });
}

function insert_log_entry(o) {
    var now = new Date();
    var participant_name = "";

    if (o.participant_id) {
        participant_name = window_status.$("#participant-" + o.participant_id + " .name").text();
        participant_name += ": ";
    }

    var $log_entry = $('<div class="log-entry" />').append(
        $('<div class="created-time" />').text(
            moment(now).format('hh:mm:ss')
        )
    ).append(
        $('<div class="message" />').text(
            participant_name + o.message
        )
    );

    if (o.extra_data) {
        $log_entry.append(
            $('<div class="extra-data" />').text(
                JSON.stringify(o.extra_data)
            )
        );
    }

    window_status.$("#logParticipants").append(
        $log_entry
    );
}

function set_participant_status_online(participant_id) {
    set_participant_status(participant_id, "online");
    if (window_status && window_status.window_is_loaded) {
        var $p = window_status.$("#participant-" + participant_id);
        var $mute_all = window_status.$("muteAllParticipants");
        
        $p.find("input").prop("disabled", false);
        $p.find("button").prop("disabled", false);

        // Si tiene el check puesto tendremos que volver a mutearlo
        if($p.find('.mute-participant').prop('checked') || $mute_all.prop('checked')) {
            STREAM_VG.mute(participant_id);
        }

        if($p.find('.share-screen').prop('checked') || $mute_all.prop('checked')) {
            STREAM_VG.share_screen(participant_id);
        }

        var window_index = $p.data("window-index");
        var $window = window_index ? extra_windows[window_index - 1].$ : window.$;
        $window("#participant-" + participant_id).removeClass("offline").addClass("online");
    }
}

function set_participant_status_offline(participant_id) {
    set_participant_status(participant_id, "offline");
    if (window_status && window_status.window_is_loaded) {
        var $p = window_status.$("#participant-" + participant_id);
        $p.find("input").prop("disabled", true);
        $p.find("button").prop("disabled", true);

        var window_index = $p.data("window-index");
        var $window = window_index ? extra_windows[window_index - 1].$ : window.$;
        $window("#participant-" + participant_id).removeClass("online").addClass("offline");
    }
}

function set_participant_status(participant_id, status) {
    var $sw = window_status.$;

    $sw("#participant-" + participant_id).data("status", status);

    var $status = $sw("#participant-" + participant_id + " .status");

    if (status == "online") {
        $status.removeClass("alert-danger").addClass("alert-success");
    } else {
        $status.removeClass("alert-success").addClass("alert-danger");
    }

    $sw("#participant-" + participant_id + " .status").text(status.toUpperCase());
}

function window_open(options) {
    var left = wo_left;
    var top = wo_top;
    wo_left = wo_left + 80;
    wo_top = wo_top + 80;
    var width = window.screen.width / 2;
    var height = window.screen.height / 2;

    var new_window = window.open(
        options.url,
        options.name,
        options.config ? options.config : 
            "width=" + width + ", height=" + height + 
            ", top=" + top + ",left=" + left + ",directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,resizable=yes,scrollbars=yes"
    );

    new_window.window_is_loaded = false;
    var window_document = new_window.document;
    new_window.addEventListener('load', function () {
        new_window.jQuery(window_document).ready(function () {
            if (options.on_document_ready) {
                options.on_document_ready(new_window);
            }

            new_window.alertDialog.show({
                title: "",
                message: "Ventana cargada",
                onHide: function () {
                    new_window.jQuery("video").trigger("play");
                }
            });

            new_window.window_is_loaded = true;
        });
    }, false);

    return new_window;
}

/* COPY PASTA:

var wwcc = extra_windows[i];
var window_document = wwcc.document;
wwcc.addEventListener('load', function () {
    wwcc.jQuery(window_document).ready(function () {
        wwcc.$("body .page-content").html("<h1>XXX</h1>");
        // console.log(window_child.jQuery("body .page-content").html());
    });
}, false);
*/